angular.module('iw.frontyard.common', [
]);